import { render, staticRenderFns } from "./info-table.vue?vue&type=template&id=31286c42&scoped=true&"
import script from "./info-table.vue?vue&type=script&lang=js&"
export * from "./info-table.vue?vue&type=script&lang=js&"
import style0 from "./info-table.vue?vue&type=style&index=0&id=31286c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31286c42",
  null
  
)

export default component.exports